import gql from 'graphql-tag';

// 登录
export const login = gql`query login(
    $supplierNo: String!, $password: String!
) {
    login(
        supplierNo: $supplierNo, password: $password
    ) {
        code,
        message,
        data {
            accessToken,
            expiresIn
        }
    }
}`;

// 获取所有可进入的组织
export const getAllClique = gql`query getAllClique(
    $supplierNo: String
) {
    getAllClique(
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data {
            cliqueNo,
            cliqueName
        }
    }
}`;

// 获取供应商信息
export const findInfoBySupplierNo = gql`query findInfoBySupplierNo(
    $supplierNo: String!
) {
    findInfoBySupplierNo(
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data {
            id
            supplierName
            supplierNo
            mobile
            level
            createdAt
            updatedAt
        }
    }
}`;

// 修改密码
export const findPassword = gql`mutation findPassword(
    $supplierNo: String!
    $password: String!
    $newPassword: String!
) {
    findPassword(
        supplierNo: $supplierNo
        password: $password
        newPassword: $newPassword
    ) {
        code,
        message
    }
}`;

// 获取单据列表
export const selectAllOriginalInfo = gql`query selectAllOriginalInfo(
    $condi: Condi
    $cliqueNo: String
) {
    selectAllOriginalInfo(
        condi: $condi
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        total,
        data {
            originNo
            projectId
            quotationNo
            settleChannel
            destroyStatus
            originStatus
            organNo
            path
            originalItemsCount
            productCount
            orderAmount
            docNo
            orderStatus
            destroyOriginNo
            submitAt
            createdAt
            updatedAt
            postAt
            sync
            isLocked
        },
        totalCount,
        totalPrince
    }
}`;

// 修改单据同步状态
export const updateOriginalSync = gql`mutation updateOriginalSync(
    $originNo: String
) {
    updateOriginalSync(
        originNo: $originNo
    ) {
        code,
        message
    }
}`;

// 根据原始单号查询原始单据
export const getOriginalByOriginNo = gql`query getOriginalByOriginNo(
    $originNo: String
    $cliqueNo: String
) {
    getOriginalByOriginNo(
        originNo: $originNo
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            dataSource
            originNo
            projectId
            quotationNo
            settleChannel
            productCount
            submitAt
            organNo
            abstract
            path
            organNoPath
            orderAmount
            supplierNo
            supplierName
            originalItemsCount
            docNo
            orderStatus
            originStatus
            createdAt
            updatedAt
            postAt
            ladingBill
            ladingBillName
            acceptNo
            acceptName
            acceptAt
            items {
                serialNum
                productName
                productSpectype
                productCount
                unitPrice
                totalPrice
                classifyNo
                classifyName
                productNo
                productUnit
                productSpec
                spu
                price1
                price2
                type
                supplyCount
            }
        }
    }
}`;

// 查询物资分类列表 && 暂时定义四级嵌套，如果需要更多，请手动添加
export const queryProductClassify = gql`query queryProductClassify(
    $cliqueNo: String!
    $supplierNo: String!
) {
    queryProductClassify(
        cliqueNo: $cliqueNo
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data
    }
}`;

// 根据物资分类查询物资信息
export const queryProductByClassifyNo = gql`query queryProductByClassifyNo(
    $pageNumber: Int
    $pageSize: Int
    $classifyNo: String
    $cliqueNo: String!
    $productName: String
    $productNo: String
    $projectId: String
) {
    queryProductByClassifyNo(
        pageNumber: $pageNumber
        pageSize: $pageSize
        classifyNo: $classifyNo
        cliqueNo: $cliqueNo
        productName: $productName
        productNo: $productNo
        projectId: $projectId
    ) {
        code,
        message,
        count,
        data {
            id
            productno
            productspu
            productname
            productspectype
            classifyname
            classifyno
            productspec
            productunit
            price
        }
    }
}`;

// 获取组织下所有可供货部门
export const getAllOrgan = gql`query getAllOrgan(
    $cliqueNo: String
    $supplierNo: String
) {
    getAllOrgan(
        cliqueNo: $cliqueNo
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data
    }
}`;

// 手动创建单据
export const createOriginalInfo = gql`mutation createOriginalInfo(
    $originalInfo: OriginalInfoInput!
) {
    createOriginalInfo(
        originalInfo: $originalInfo
    ) {
        code,
        message,
        data
    }
}`;

// 模板创建原始单据
export const createTemplateOriginalInfo = gql`mutation createTemplateOriginalInfo(
    $templateOriginalInfo: TemplateOriginalInfo!
) {
    createTemplateOriginalInfo(
        templateOriginalInfo: $templateOriginalInfo
    ) {
        code,
        message,
        data
    }
}`;

// 查询模板下载的所有一级分类
export const queryClassifyOne = gql`query queryClassifyOne(
    $cliqueNo: String!
) {
    queryClassifyOne(
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data
    }
}`;

// 查询一级分类下的所有商品(classifyNos不传查全部)
export const queryProductByClassifyNos = gql`query queryProductByClassifyNos(
    $cliqueNo: String!
    $classifyNos: [String]
    $supplierNo: String!
) {
    queryProductByClassifyNos(
        cliqueNo: $cliqueNo
        classifyNos: $classifyNos
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data
    }
}`;

// 打回订单
export const deleteOriginalInfo = gql`mutation deleteOriginalInfo(
    $originNo: String
) {
    deleteOriginalInfo(
        originNo: $originNo
    ) {
        code,
        message
    }
}`;

// 撤回订单
export const rejectOriginalInfo = gql`mutation rejectOriginalInfo(
    $originNo: String
) {
    rejectOriginalInfo(
        originNo: $originNo
    ) {
        code,
        message
    }
}`;

// 销售汇总
export const countSales = gql`query countSales(
    $condi: CountCondi
    $supplierNo: String
    $cliqueNo: String
) {
    countSales(
        condi: $condi
        supplierNo: $supplierNo
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            serialNum
            organNo
            organName
            totalAmount
            totalCount
        },
    }
}`;

// 修改打回订单
export const modifyOriginalInfo = gql`mutation modifyOriginalInfo(
    $originNo: String
    $modifyInfo: ModifyInfoInput
) {
    modifyOriginalInfo(
        originNo: $originNo
        modifyInfo: $modifyInfo
    ) {
        code,
        message
    }
}`;

// 获取所有结算渠道
export const getAllSettleChannel = gql`query getAllSettleChannel(
    $cliqueNo: String,
    $all: Int,
) {
    getAllSettleChannel(
        cliqueNo: $cliqueNo,
        all: $all
    ) {
        code,
        message,
        data{
            alias
            name
        }
    }
}`;

// 获取所有规格
export const getAllSpec = gql`query getAllSpec(
    $type: String
) {
    getAllSpec(
        type: $type
    ) {
        code,
        message,
        data
    }
}`;

// 查看申报新物资
export const getAllRequest = gql`query getAllRequest(
    $pageNumber: Int
    $pageSize: Int
) {
    getAllRequest(
        pageNumber: $pageNumber
        pageSize: $pageSize
    ) {
        code,
        message,
        count,
        data {
            id
            status
            productName
            supplierName
            productSpectype
            productUnit
            classifyName
            normalProductUnit
            rate
        }
    }
}`;

// 新物资申请记录
export const getMyRequest = gql`query getMyRequest(
    $pageNumber: Int
    $pageSize: Int
    $supplierNo: String
    $cliqueNo: String
    $condi: RequestCondi
) {
    getMyRequest(
        pageNumber: $pageNumber
        pageSize: $pageSize
        supplierNo: $supplierNo
        cliqueNo: $cliqueNo
        condi: $condi
    ) {
        code,
        message,
        count,
        data {
            id
            status
            reason
            productName
            productSpectype
            classifyName
            productUnit
            classifyNo
            normalProductUnit
            rate
        }
    }
}`;

// 修改物资申请并重新提交
export const modifyRequest = gql`mutation modifyRequest(
    $id: Int
    $productName: String
    $classifyNo: String
    $productSpectype: String
    $productUnit: String
    $normalProductUnit: String
    $rate: String
) {
    modifyRequest(
        id: $id,
        productName: $productName,
        classifyNo: $classifyNo,
        productSpectype: $productSpectype,
        productUnit: $productUnit,
        normalProductUnit: $normalProductUnit
        rate: $rate
    ) {
        code,
        message
    }
}`;

// 审批新物资申请
export const checkRequest = gql`mutation checkRequest(
    $ids: [Int]
    $operate: Int
    $reason: String
) {
    checkRequest(
        ids: $ids
        operate: $operate
        reason: $reason
    ) {
        code,
        message
    }
}`;

// 提交新物资申请
export const createRequest = gql`mutation createRequest(
    $supplierNo: String,
    $productName: String,
    $classifyNo: String,
    $productSpectype: String,
    $productUnit: String,
    $cliqueNo: String,
    $normalProductUnit: String,
    $rate: String
) {
    createRequest(
        supplierNo: $supplierNo,
        productName: $productName,
        classifyNo: $classifyNo,
        productSpectype: $productSpectype,
        productUnit: $productUnit,
        cliqueNo: $cliqueNo,
        normalProductUnit: $normalProductUnit,
        rate: $rate
    ) {
        code,
        message
    }
}`;

// 保存草稿单据
export const saveDraft = gql`mutation saveDraft(
    $originalInfo: OriginalInfoInput!
) {
    saveDraft(
        originalInfo: $originalInfo
    ) {
        code,
        message
    }
}`;

// 计划管理
// 判断该厂是否启用模块
export const queryFunction = gql`query queryFunction(
    $cliqueNo: String
) {
    queryFunction(
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data
    }
}`;

// 获取计划版本
export const getProjectVersion = gql`query getProjectVersion(
    $cliqueNo: String
) {
    getProjectVersion(
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            id
            versionId
            versionName
        }
    }
}`;

// 获取计划类型
export const getProjectType = gql`query getProjectType(
    $cliqueNo: String
) {
    getProjectType(
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            id
            typeId
            typeName
        }
    }
}`;

// 计划列表
export const getAllProjects = gql`query getAllProjects(
    $cliqueNo: String!
    $supplierNo: String!
    $projectId: String
    $organNo: String
    $version: String
    $type: String
    $period: String
    $pageNumber: Int
    $pageSize: Int
) {
    getAllProjects(
        cliqueNo: $cliqueNo
        supplierNo: $supplierNo
        projectId: $projectId
        organNo: $organNo
        version: $version
        type: $type
        period: $period
        pageNumber: $pageNumber
        pageSize: $pageSize
    ) {
        code,
        message,
        data {
            id
            projectId
            quotationNo
            type
            version
            period
            projectStatus
            organNo
            isUpdated
            isLocked
            settleChannel
        }
        pager {
            totalItems
            currentPage
            pageSize
        }
    }
}`;

export const getMyProjects = gql`query getMyProjects(
    $cliqueNo: String!
    $supplierNo: String!
) {
    getMyProjects(
        cliqueNo: $cliqueNo
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data {
            id
            projectId
            isLocked
        }
    }
}`;

// 查看计划详情
export const getOneProject = gql`query getOneProject(
    $projectId: String
) {
    getOneProject(
        projectId: $projectId
    ) {
        code,
        message,
        data {
            id
            projectId
            quotationNo
            projectType
            versionId
            period
            abstract
            projectStatus
            organNo
            path
            settleChannel
            totalItem
            totalNumber
            items{
                productNo
                productName
                productSpectype
                classifyName
                serialNum
                productCount
                unitPrice
                totalPrice
            }
            history{
                id
                projectId
                quotationNo
                projectType
                versionId
                period
                abstract
                projectStatus
                organNo
                path
                settleChannel
                totalItem
                totalNumber
                items{
                    productNo
                    productName
                    productSpectype
                    classifyName
                    serialNum
                    productCount
                    unitPrice
                    totalPrice
                }
            }
        }
    }
}`;

// 报价计划
export const quoTePrice = gql`mutation quoTePrice(
    $supplierNo: String!
    $project: QuoteProjectInput
) {
    quoTePrice(
        supplierNo: $supplierNo
        project: $project
    ) {
        code,
        message
    }
}`;

// 确认计划
export const checkProject = gql`mutation checkProject(
    $supplierNo: String!
    $projectId: String
) {
    checkProject(
        supplierNo: $supplierNo
        projectId: $projectId
    ) {
        code,
        message
    }
}`;

// 获取计划物资的可供应数量和价格
export const getProjectSupply = gql`query getProjectSupply(
    $projectId: String
) {
    getProjectSupply(
        projectId: $projectId
    ) {
        code,
        message,
        data {
            id
            productNo
            productName
            productSpectype
            classifyName
            serialNum
            productCount
            supplyCount
            unitPrice1
            unitPrice2
        }
    }
}`;

// 添加供应商
export const addSupplier = gql`mutation addSupplier(
    $supplierInfo: SupplierInfoInput
    $cliqueNos: [String]
    $cliassifys: [String]
) {
    addSupplier(
        supplierInfo: $supplierInfo
        cliqueNos: $cliqueNos
        cliassifys: $cliassifys
    ) {
        code
        message
        data
    }
}`;

// 管理员获取全部物资分类
export const adminGetAllClassify = gql`query adminGetAllClassify{
    adminGetAllClassify{
        code,
        message,
        data {
            classifyId
            classifyName
            classifyNo
        }
    }
}`;

// 同步物资
export const syncProduct = gql`mutation syncProduct(
    $productNo: String
) {
    syncProduct(
        productNo: $productNo
    ) {
        code
        message
        data
    }
}`;

// 管理员查询供应商列表
export const adminGetSupplierList = gql`query adminGetSupplierList(
    $condi: SupplierListCondi
) {
    adminGetSupplierList(
        condi: $condi
    ) {
        code,
        message,
        data {
            id
            supplierNo
            supplierName
            username
            mobile
            password
        }
        total
    }
}`;

export const adminGetSupplierInfo = gql`query adminGetSupplierInfo(
    $id: Int
) {
    adminGetSupplierInfo(
        id: $id
    ) {
        code,
        message,
        data {
            id
            supplierNo
            supplierName
            password
            username
            mobile
            cliqueNos
            classifys
        }
    }
}`;

export const updateSupplier = gql`mutation updateSupplier(
    $supplierNo: String
    $cliqueNos: [String]
) {
    updateSupplier(
        supplierNo: $supplierNo
        cliqueNos: $cliqueNos
    ) {
        code
        message
        data
    }
}`;

// 根据物资分类查询本厂物资价格
export const queryProductPriceByClassifyNo = gql`query queryProductPriceByClassifyNo(
    $pageNumber: Int
    $pageSize: Int
    $classifyNo: String
    $productName: String
    $productNo: String
    $cliqueNo: String!
) {
    queryProductPriceByClassifyNo(
        pageNumber: $pageNumber
        pageSize: $pageSize
        classifyNo: $classifyNo
        productName: $productName
        productNo: $productNo
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            id
            productno
            productspu
            productname
            productspectype
            classifyname
            classifyno
            productspec
            price
        }
        count
    }
}`;

// 修改物资价格
export const updateProductPrice = gql`mutation updateProductPrice(
    $cliqueNo: String
    $productPrices: [ProductPricesInput]
) {
    updateProductPrice(
        cliqueNo: $cliqueNo
        productPrices: $productPrices
    ) {
        code
        message
        data
    }
}`;

// 询价单列表
export const selectAllQuotationInfo = gql`query selectAllQuotationInfo(
    $condi: QuotationCondi
    $cliqueNo: String
) {
    selectAllQuotationInfo(
        condi: $condi
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            id
            cliqueNo
            supplierNo
            supplierName
            quotationNo
            name
            startTime
            endTime
            state
            sync
            createdAt
            updatedAt
        }
        pager {
            totalItems
            currentPage
            pageSize
        }
    }
}`;

// 询价单详情
export const getQuotationByQuotationNo = gql`query getQuotationByQuotationNo(
    $quotationNo: String
) {
    getQuotationByQuotationNo(
        quotationNo: $quotationNo
    ) {
        code,
        message,
        data {
            id
            name
            cliqueNo
            supplierNo
            supplierName
            organNo
            organName
            startTime
            endTime
            quotationNo
            state
            createdAt
            updatedAt
            quotationItems{
                id
                serialCount
                productNo
                productName
                productSpec
                productSpectype
                price
            }
        }
    }
}`;

// 导入询价单
export const importQuotation = gql`mutation importQuotation(
    $quotationInfo: QuotationInfoInput
) {
    importQuotation(
        quotationInfo: $quotationInfo
    ) {
        code
        message
    }
}`;

// 修改询价单
export const updateQuotation = gql`mutation updateQuotation(
    $quotationInfo: QuotationInfoInput
    $id: Int
) {
    updateQuotation(
        quotationInfo: $quotationInfo
        id: $id
    ) {
        code
        message
    }
}`;

// 发布询价单
export const publishQuotation = gql`mutation publishQuotation(
    $id: Int
) {
    publishQuotation(
        id: $id
    ) {
        code
        message
    }
}`;

// 作废询价单
export const repealQuotation = gql`mutation repealQuotation(
    $id: Int
) {
    repealQuotation(
        id: $id
    ) {
        code
        message
    }
}`;
// 同步
export const syncQuotation = gql`mutation syncQuotation(
    $id: Int
) {
    syncQuotation(
        id: $id
    ) {
        code
        message
    }
}`;

// 获取供应商可供应的厂
export const getSupplierClique = gql`query getSupplierClique(
    $supplierNo: String
) {
    getSupplierClique(
        supplierNo: $supplierNo
    ) {
        code,
        message,
        data {
            cliqueNo
            cliqueName
        }
    }
}`;
// 三厂查询物资
export const queryAllProduct = gql`query queryAllProduct(
    $pageNumber: Int
    $pageSize: Int
    $classifyNo: String
    $cliqueNo: String
    $productName: String
    $productNo: String
    $state: Int
) {
    queryAllProduct(
        pageNumber: $pageNumber
        pageSize: $pageSize
        classifyNo: $classifyNo
        cliqueNo: $cliqueNo
        productName: $productName
        productNo: $productNo
        state: $state
    ) {
        code,
        message,
        count,
        data {
            id
            productno
            productname
            productspectype
            classifyname
            classifyno
            productspec
            state
        }
    }
}`;

// 启用物资
export const enableProduct = gql`mutation enableProduct(
    $products: [InputProducts]
    $cliqueNo: String
) {
    enableProduct(
        products: $products
        cliqueNo: $cliqueNo
    ) {
        code
        message
    }
}`;

export const disableProduct = gql`mutation disableProduct(
    $products: [InputProducts]
    $cliqueNo: String
) {
    disableProduct(
        products: $products
        cliqueNo: $cliqueNo
    ) {
        code
        message
    }
}`;

// 获取该询价单内物资价格
export const getQuotationPrice = gql`query getQuotationPrice(
    $quotationNo: String
) {
    getQuotationPrice(
        quotationNo: $quotationNo
    ) {
        code,
        message,
        data {
            productNo
            price
        }
    }
}`;

// 搜索询价单列表(创建单据页面)
export const selectQuotationInfoList = gql`query selectQuotationInfoList(
    $condi: QuotationCondi
    $cliqueNo: String
) {
    selectQuotationInfoList(
        condi: $condi
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            id
            cliqueNo
            supplierNo
            supplierName
            quotationNo
            name
            startTime
            endTime
            state
            sync
            createdAt
            updatedAt
        }
        pager {
            totalItems
            currentPage
            pageSize
        }
    }
}`;

// 物资销售汇总
export const aggregateProducts = gql`query aggregateProducts(
    $condi: CountCondi
    $supplierNo: String
    $cliqueNo: String
) {
    aggregateProducts(
        condi: $condi
        supplierNo: $supplierNo
        cliqueNo: $cliqueNo
    ) {
        code,
        message,
        data {
            serialNum
            productName
            classifyName
            productNo
            productSpectype
            productSpec
            totalPrice
            totalCount
        },
    }
}`;



// WEBPACK FOOTER //
// ./src/graphql/graphql.js